import React, { useEffect } from 'react';
import Header from './Header';
import StudyAdroad from './studyAdroad';
import Footer from './Footer';
import ServiceBox from './ServiceBox';
import CoursesBox from './CoursesBox';
import B2C from './B2C';
import B2B from './B2B';
import Global from './Global';
const Home = () => {
    useEffect(() => {
      document.documentElement.scrollTop=0
    }, []);
    
    
    return (
        <>
            <Header />
            <ServiceBox />
            <CoursesBox/>
            <B2C/>
            <Global/>
            {/* <StudyAdroad /> */}
            <B2B title="Educational institutes"/>
            <B2B title="Enterprises"/>
        </>
    );
};

export default Home;